import { render, staticRenderFns } from "./AssetsUpload.vue?vue&type=template&id=e7a56498&"
import script from "./AssetsUpload.vue?vue&type=script&lang=js&"
export * from "./AssetsUpload.vue?vue&type=script&lang=js&"
import style0 from "./AssetsUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports